import { GoogleTagManager } from '@next/third-parties/google'
import * as Sentry from '@sentry/nextjs'
import { NextPage } from 'next'
import type { AppProps } from 'next/app'
import Router from 'next/router'
import React, { ReactElement, useEffect } from 'react'
import { Slide, ToastContainer } from 'react-toastify'

import '@/flutter'

// import to start history tracking
import '@/NextHistory'

import { UpdateMonitor } from '@/update-monitor/UpdateMonitor'

import 'react-toastify/dist/ReactToastify.css'
import '../styles/globals.scss'
import '../styles/react-ranger.scss'

export type NextPageWithLayout<P = {}, IP = P> = NextPage<P, IP> & {
  getLayout?: (page: ReactElement) => JSX.Element
}

type AppPropsWithLayout = AppProps & {
  Component: NextPageWithLayout
}

function MyApp({ Component, pageProps }: AppPropsWithLayout) {
  const getLayout = Component.getLayout ?? ((page) => page)

  useEffect(() => {
    const isPartner = !!Router.pathname.match(/^\/partner-admin\/?/)
    if (isPartner) {
      Sentry.setTag('logic_app', 'partner-admin')
      return
    }
    const isWeb = !!Router.pathname.match(/^\/web\/?/)
    Sentry.setTag('logic_app', isWeb ? 'guardian_web' : 'guardian_app')
  }, [])

  return (
    <UpdateMonitor>
      {getLayout(<Component {...pageProps} />)}

      {process.env.NEXT_PUBLIC_GTM_ID && (
        <GoogleTagManager gtmId={process.env.NEXT_PUBLIC_GTM_ID} />
      )}
      <MemoToastContainer
        hideProgressBar={true}
        transition={Slide}
        icon={false}
        closeButton={false}
      />
    </UpdateMonitor>
  )
}
export default MyApp

const MemoToastContainer = React.memo(ToastContainer)
